export default __webpack_public_path__ + "static/media/car.d459aa61.svg";